import { Box } from '@mui/material';
import { CSSProperties } from 'react';
import { Flex } from 'src/components/Flex';
import { BOX_SHADOW, DEFAULT_BORDER_RADIUS, DEFAULT_BORDER_STYLE, DEFAULT_BORDER_WIDTH } from 'src/constants';

interface Product {
    id: number;
    name: string;
    quantity: number;
    price: number;
}

interface ModalTableProps {
    modalMessage: string;
    products: Product[];
}

const ModalTable: React.FC<ModalTableProps> = ({ modalMessage, products }) => {
    const lastProduct = products[products.length - 1];

    const sharedCellStyle: CSSProperties = {
        padding: '12px',
        borderRightWidth: DEFAULT_BORDER_WIDTH,
        borderRightStyle: DEFAULT_BORDER_STYLE as 'solid',
        borderRightColor: 'border.light',
        borderBottomWidth: DEFAULT_BORDER_WIDTH,
        borderBottomStyle: DEFAULT_BORDER_STYLE as 'solid',
        borderBottomColor: 'border.light',
    };

    return (
        <Flex flexDirection="column" gap="16px">
            <Box
                component="p"
                sx={{
                    margin: '8px',
                }}
            >
                {modalMessage}
            </Box>
            <Box
                sx={{
                    padding: '12px',
                    boxShadow: BOX_SHADOW,
                    overflow: 'hidden',
                    borderRadius: DEFAULT_BORDER_RADIUS,
                }}
            >
                {/* Table Headers */}
                <Box
                    component="table"
                    sx={{
                        width: '100%',
                        borderCollapse: 'separate',
                        borderSpacing: '0',
                        borderRadius: '4px',
                        border: '1px solid black',
                        backgroundColor: 'grey.300',
                        textAlign: 'left',
                        tableLayout: 'fixed',
                    }}
                    aria-label="Product Header"
                >
                    <colgroup>
                        <col style={{ width: '50%' }} />
                        <col style={{ width: '25%' }} />
                        <col style={{ width: '25%' }} />
                    </colgroup>
                    <thead>
                        <tr>
                            <th style={{ borderRight: '1px solid black', padding: '12px' }}>Product</th>
                            <th style={{ borderRight: '1px solid black', padding: '12px' }}>Quantity</th>
                            <th style={{ padding: '12px' }}>Price</th>
                        </tr>
                    </thead>
                </Box>

                {/* Product List */}
                <Box component="div" sx={{ marginTop: '8px' }}>
                    <Box
                        component="table"
                        sx={{
                            width: '100%',
                            borderSpacing: '0',
                            borderRadius: '4px',
                            borderColor: 'border.light',
                            borderWidth: DEFAULT_BORDER_WIDTH,
                            borderStyle: DEFAULT_BORDER_STYLE,
                            tableLayout: 'fixed',
                        }}
                        aria-label="Product List"
                    >
                        <colgroup>
                            <col style={{ width: '50%' }} />
                            <col style={{ width: '25%' }} />
                            <col style={{ width: '25%' }} />
                        </colgroup>
                        <tbody>
                            {products.map((product) => (
                                <tr key={product.id}>
                                    <Box
                                        component="td"
                                        sx={{
                                            ...sharedCellStyle,
                                            borderBottom: product === lastProduct ? 'none' : sharedCellStyle.borderBottom,
                                        }}
                                    >
                                        {product.name}
                                    </Box>
                                    <Box
                                        component="td"
                                        sx={{
                                            ...sharedCellStyle,
                                            borderBottom: product === lastProduct ? 'none' : sharedCellStyle.borderBottom,
                                        }}
                                    >
                                        {product.quantity}
                                    </Box>
                                    <Box
                                        component="td"
                                        sx={{
                                            ...sharedCellStyle,
                                            borderRight: 'none',
                                            borderBottom: product === lastProduct ? 'none' : sharedCellStyle.borderBottom,
                                        }}
                                    >
                                        {product.price}
                                    </Box>
                                </tr>
                            ))}
                        </tbody>
                    </Box>
                </Box>
            </Box>
        </Flex>
    );
};

export default ModalTable;
